<div class="check-price-avail-widget">
  <form [formGroup]="priceAvailabilityForm" class="price-avail-form">
    <div class="part-no-holder vs-text-field">
      <label class="pna-form-label"
        >{{ 'landing.partno' | cxTranslate }} <span class="star">*</span></label
      >
      <input
        type="text"
        formControlName="partNumber"
        placeholder="{{ 'landing.partNoPlaceholder' | cxTranslate }}"
        class="float-left"
        [class.error]="this.formSubmitted && this.f['partNumber'].invalid"
      />
      <label
        class="error float-left"
        *ngIf="this.formSubmitted && this.f['partNumber'].invalid"
      >
        {{ 'landing.partnumber' | cxTranslate }}
      </label>
    </div>
    <div class="quantity-holder vs-text-field">
      <label class="pna-form-label"
        >{{ 'landing.qty' | cxTranslate }} <span class="star">*</span></label
      >
      <input
        type="text"
        formControlName="quantity"
        class="float-left"
        (keypress)="numberOnly($event)"
        (blur)="onQtyBlur($event)"
        maxlength="4"
      />
      <!-- <label class="error float-left" *ngIf="this.formSubmitted && this.f.quantity.invalid">
                Add Quantity
            </label> -->
    </div>
    <div class="requested-date-holder">
      <label class="pna-form-label">{{
        'landing.shipdate' | cxTranslate
      }}</label>
      <vs-date-picker
        (selectedDate)="dateChange($event)"
        [defaultDate]="defaultDate"
        [filterWeekend]="filterWeekend"
        [min]="minDate"
      ></vs-date-picker>
    </div>
    <div class="action-holder">
      <button class="vs-primary-btn" (click)="checkPriceAndAvailability()">
        <span>{{ 'landing.checkava' | cxTranslate }}</span>
        <div *ngIf="fetchingPnA" class="availability-spinner cx-spinner">
          <cx-spinner></cx-spinner>
        </div>
      </button>
    </div>
  </form>
  <div *ngIf="showResults" class="price-availability-result">
    <div class="product-info">
      <p class="mb-0 product-name">{{ productDetails.name }}</p>
      <p class="mb-0 product-code">{{ productDetails.code }}</p>
      <div
        *ngIf="productDetails.newLegacyCode"
        class="text-warning legacy-text"
      >
        <span class="material-icons">warning </span
        >{{ 'landing.replacementPartFor' | cxTranslate }}
        {{ productDetails.newLegacyCode }}
      </div>
    </div>
    <ng-container
      *ngIf="
        !productDetails.obsoleteProductFlag &&
        productDetails.availabilityInfo &&
        !productDetails.availabilityError
      "
    >
      <div class="row price-avail-info">
        <div class="list-price col-3">
          <span class="content-header">{{
            'landing.listprice' | cxTranslate
          }}</span>
          <span class="list-price-value"
            >{{ productDetails.price.currencyIso }}
            {{ productDetails.price.formattedValue }}</span
          >
          <span class="unit-value">{{ 'landing.perunit' | cxTranslate }}</span>
        </div>
        <div class="avail-at col-6">
          <span class="content-header"
            >{{ 'landing.shippedfrom' | cxTranslate }}
          </span>
          <select
            class="mb-1 mt-1"
            (change)="onLegalEntitySelect($event)"
            [(ngModel)]="selectedLegalEntity"
          >
            <!-- <option disabled selected hidden>Select</option> -->
            <option
              *ngFor="let entity of shippedFrmOptions; let i = index"
              [ngValue]="entity"
              [selected]="selectedLegalEntity?.uid == entity.uid"
            >
              {{ entity.name }} ({{ entity.stockAvailable | number : '1.0-0' }})
            </option>
          </select>
        </div>
      </div>

      <div class="row price-avail-info mt-3">
        <div class="your-price col-3">
          <span class="content-header">{{
            'landing.yourprice' | cxTranslate
          }}</span>
          <span class="your-price-value"
            >{{ productDetails.netPrice.currencyIso }}
            {{ productDetails.netPrice.formattedValue }}</span
          >
          <div
            *ngIf="
              productDetails.expressAdderPriceData &&
              productDetails.expressAdderPriceData?.value > -1
            "
            class="material-icons"
            matTooltipClass="vs-tooltip"
            matTooltip="{{
              'savedCart.expressDeliveryTooltipTxt' | cxTranslate
            }}"
            matTooltipPosition="above"
            (click)="this.breakUp = !this.breakUp"
            class="breakup-link link-color-eda"
            #viewBreakupLink
          >
            {{ 'landing.viewbreak' | cxTranslate }}
            <i *ngIf="!breakUp" class="material-icons">keyboard_arrow_down</i>
            <i *ngIf="breakUp" class="material-icons">keyboard_arrow_right</i>
          </div>
          <a
            *ngIf="
              !(
                productDetails.expressAdderPriceData &&
                productDetails.expressAdderPriceData?.value > -1
              )
            "
            (click)="this.breakUp = !this.breakUp"
            class="breakup-link link-color"
            #viewBreakupLink
          >
            {{ 'landing.viewbreak' | cxTranslate }}
            <i *ngIf="!breakUp" class="material-icons">keyboard_arrow_down</i>
            <i *ngIf="breakUp" class="material-icons">keyboard_arrow_right</i>
          </a>
          <div
            class="breakup-dropdown product-data-text"
            *ngIf="breakUp"
            #breakupContent
          >
            <div class="row list-price-row m-0">
              <span class="price-menu-heading bold">{{
                'landing.listprice' | cxTranslate
              }}</span>
              <span class="price-menu-content bold"
                >{{ productDetails.price?.currencyIso }}
                {{ productDetails.price?.formattedValue }}</span
              >
            </div>
            <div class="mb-4" *ngIf="productDetails.discountValues?.length > 0">
              <div
                class="row discounts"
                *ngFor="let discounts of productDetails.discountValues"
              >
                <span class="price-menu-heading col-6 p-0">{{
                  getDiscountName(discounts.code)
                }}</span>
                <span class="price-menu-content col-2 p-0"
                  >{{ discounts.appliedValue }}%</span
                >
                <span class="price-menu-content col-4 p-0 text-right"
                  >{{ discounts.currency }} -{{
                    discounts.formattedValue
                  }}</span
                >
              </div>
            </div>
            <div
              class="row total-adders"
              *ngIf="
                productDetails.marketPremiumPriceData &&
                productDetails.marketPremiumPriceData?.value > -1
              "
            >
              <span class="price-menu-heading col-6 p-0">{{
                'landing.aftermarket' | cxTranslate
              }}</span>
              <span class="price-menu-content col-2 p-0"
                >{{ productDetails.afterMarketPremium }}%</span
              >
              <span class="price-menu-content col-4 p-0 text-right"
                >{{ productDetails.marketPremiumPriceData?.currencyIso }}
                {{
                  productDetails.marketPremiumPriceData?.formattedValue
                }}</span
              >
            </div>
            <div
              class="row total-adders"
              *ngIf="
                productDetails.expressAdderPriceData &&
                productDetails.expressAdderPriceData?.value > -1
              "
            >
              <span class="price-menu-heading col-6 p-0">{{
                'landing.express' | cxTranslate
              }}</span>
              <span class="price-menu-content col-2 p-0"
                >{{ productDetails.expressAdderPercent }}%</span
              >
              <span class="price-menu-content col-4 p-0 text-right"
                >{{ productDetails.expressAdderPriceData?.currencyIso }}
                {{ productDetails.expressAdderPriceData?.formattedValue }}</span
              >
            </div>
            <!--Tariff Surchanrge div start-->
            <div
              class="row total-adders"
              *ngIf="
                productDetails?.tariffChargesPriceData &&
                productDetails?.tariffChargesPriceData?.value > -1
              "
            >
              <span class="price-menu-heading col-6 p-0">{{
                'landing.tariffSurcharge' | cxTranslate
              }}</span>
              <span class="price-menu-content col-2 p-0"
                >{{ productDetails.tariffChargesPercent }}%</span
              >
              <span class="price-menu-content col-4 p-0 text-right"
                >{{ productDetails.tariffChargesPriceData?.currencyIso }}
                {{ productDetails.tariffChargesPriceData?.formattedValue }}</span
              >
            </div>
             <!--Tariff Surchanrge div end-->
            <hr
              *ngIf="
                productDetails?.discountValues?.length > 0 ||
                productDetails?.expressAdderPriceData?.value != 0
              "
              class="horizontal-divider"
            />
            <div
              class="row total-discounts"
              *ngIf="productDetails.discountValues?.length > 0"
            >
              <span class="price-menu-heading bold">{{
                'landing.totaladj' | cxTranslate
              }}</span>
              <span class="price-menu-content bold">
                {{ productDetails.price?.currencyIso }} -
                {{
                  productDetails.price.value - productDetails.netPrice.value
                    | currency
                      : productDetails.price?.currencyIso
                      : 'symbol-narrow'
                }}
                <!-- {{
                  getTotalDiscounts(
                    productDetails.price,
                    productDetails.netPrice
                  )
                }} -->
              </span>
            </div>
            <div class="row net-price">
              <span class="price-menu-heading bold">{{
                'landing.netprice' | cxTranslate
              }}</span>
              <span class="price-menu-content bold"
                >{{ productDetails.netPrice?.currencyIso }}
                {{ productDetails.netPrice?.formattedValue }}</span
              >
            </div>
          </div>
        </div>
        <div class="availability-info col-6" *ngIf="showCheckAvalabilityAction">
          <button
            class="vs-tertiary-btn"
            (click)="checkAvailability()"
            [disabled]="showAvailabilityLoader"
          >
            <span>{{ 'landing.checkAvailability' | cxTranslate }}</span>
            <div
              *ngIf="showAvailabilityLoader"
              class="availability-spinner cx-spinner"
            >
              <cx-spinner></cx-spinner>
            </div>
          </button>
        </div>
        <div
          class="availability-info col-6"
          *ngIf="!showCheckAvalabilityAction"
        >
          <span class="content-header">{{
            'landing.avavinfo' | cxTranslate
          }}</span>
          <p
            *ngFor="let avail of productDetails.availabilityDetail"
            class="availability-info-text m-0"
          >
            <!-- <ng-container *ngIf="getEarliestPossibleDate(avail)">
                            Earliest possible ship date for Quantity - {{ avail.committedQuantity | number }} is
                            {{ avail.committedDate | date }}
                            <span *ngIf="!item.stockAvailability">. Please get a quote for this product if needed by
                                {{ item?.customerRequestedDate | date }}</span>
                        </ng-container> -->
            <span class="block mr-2">{{
              formateDate(avail.committedDate)
            }}</span>
            <span class="avail-text">
              <span class="mr-2">{{ 'landing.for' | cxTranslate }}</span>
              <span>{{ avail.committedQuantity | number }}</span>
            </span>
          </p>
        </div>
      </div>
      <div class="row price-avail-action mt-5">
        <cx-add-to-cart
          [view]="view"
          [product]="productDetails"
          [productCode]="productDetails?.code"
          [showQuantity]="false"
          [checkAvailabilityCRD]="selectedCRDdate"
          [legalEntity]="selectedLegalEntity"
        >
        </cx-add-to-cart>
      </div>
    </ng-container>
    <ng-container *ngIf="productDetails.obsoleteProductFlag">
      <p class="obsolete-text">
        <i class="material-icons mr-2">report_problem</i>
        <span>{{ 'landing.obsolete' | cxTranslate }}</span>
      </p>
      <div
        class="row obsolete-action"
        *ngIf="productDetails.replacementProductUrl"
      >
        <button
          class="vs-primary-btn"
          (click)="
            redirectToReplacementProd(productDetails.replacementProductUrl)
          "
        >
          {{ 'landing.replacementPart' | cxTranslate }}
        </button>
      </div>
    </ng-container>
    <ng-container
      *ngIf="
        !productDetails.availabilityInfo ||
        productDetails.availabilityError == '5002'
      "
    >
      <p class="obsolete-text">
        <i class="material-icons mr-2">report_problem</i>
        <span
          >{{ 'landing.noprice' | cxTranslate }} {{ productDetails.code }}</span
        >
      </p>
    </ng-container>
    <div class="checkprice-av" *ngIf="otherInventoryLocations.length > 0">
      <div class="tabletext">
        <table class="table-pdptable">
          <thead>
            <tr class="table-pdp">
              <th>{{ 'landing.otherLocations' | cxTranslate }}</th>
              <th>{{ 'landing.noOfUnits' | cxTranslate }}</th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="let entity of otherInventoryLocations"
              class="tbaletrcheck"
            >
              <td>{{ entity.name }}</td>
              <td>{{ entity?.stockAvailable || 0 | number : '1.0-0' }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="buycheckpdp">
        <p class="pdp-checkprice">{{ 'landing.wantToBuy' | cxTranslate }}</p>
      </div>
      <div class="row buycheckpdp">
        <div class="cx-dialog-info col-md-5">
          <div class="inventory-text">
            <span>{{ 'landing.topRightPara' | cxTranslate }}</span>
          </div>
        </div>
        <div class="col-md-2">
          <div><img src="../../../../../assets/img/orImg.svg" alt="OR" /></div>
        </div>
        <div class="cx-dialog-info col-md-5 pl-0">
          <div class="inventory-text">
            <span>{{ 'landing.placeOrderPara' | cxTranslate }} </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
